import {AnyEvent, JOB_VARIATION_ALLOCATED_EVENT, JobVariationCompanyAllocatedEvent} from '../type';

export default function jobVariationCompanyAllocated(payload: JobVariationCompanyAllocatedEvent['payload']): AnyEvent {
  return {
    type: JOB_VARIATION_ALLOCATED_EVENT,
    payload,
  }
}